import {
    getFileId,
    type UploadPendingRetryUploadFile,
    type UploadPendingSendFileMeta,
} from '../../../app-core/lib/upload/Upload'
import { Logg_createLogger } from '../Logg/Logg.Logger'
import { Uplo_deleteUploads } from './Uplo.delete'
import { IDB_uploads } from '../IDB/IDB.deviceDB'
import { assumeExhaustion } from '../../../shared/lib/typeHelpers.no-deps'
import { IDB_update } from '../IDB/IDB.dexie'

/** As transients states are stored in indexed db, on start up we need to put them back
 * e.g. if the upload was uploading when the app was closed, it needs to go back to pending upload
 */
export async function Uplo_resetTransientUploads() {
    const logger = Logg_createLogger('Uplo_resetTransientUploads')
    const uploads = await IDB_uploads().toArray()

    for (const upload of uploads) {
        const fileId = getFileId(upload)

        switch (upload.status) {
            case 'UploadInvalid':
            case 'UploadWritingFileToDisk':
            case 'UploadWriteToDiskFailed':
                logger.log('Deleting upload that did not make it to disk', { status: upload.status, fileId })
                await IDB_uploads().delete(fileId)
                break

            case 'Uploaded':
            case 'UploadPendingSendFileMeta':
                break

            case 'UploadSendingFileMeta':
            case 'UploadSendFileMetaFailed': {
                logger.log('Put upload back to UploadPendingSendFileMeta', { status: upload.status, fileId })

                const resetUpload: UploadPendingSendFileMeta = {
                    ...upload,
                    status: 'UploadPendingSendFileMeta',
                    failCount: 0,
                }

                await IDB_update(IDB_uploads(), fileId, resetUpload)
                break
            }

            case 'UploadPendingRetryUploadFile':
            case 'UploadUploadingFile': {
                logger.log('Put upload back to UploadPendingRetryUploadFile', { status: upload.status, fileId })

                const resetUpload: UploadPendingRetryUploadFile = {
                    ...upload,
                    status: 'UploadPendingRetryUploadFile',
                    failCount: 0,
                }

                await IDB_update(IDB_uploads(), fileId, resetUpload)
                break
            }

            case 'UploadFailed':
            case 'UploadCancelled':
                logger.log('Deleting upload that did not make it to the server', { status: upload.status, fileId })
                await Uplo_deleteUploads(logger, [upload])
                break

            default:
                assumeExhaustion(upload)
        }
    }
}
